import React from 'react'
import AbsTag from './AbsTag'
import AdminTag from './AdminTag'

const AdminAndAbs = ({isAdmin,isAbs}) => {
  return (
    <>
        {isAdmin? <AdminTag/>:
            isAbs?
        <AbsTag/>:null}
        </>
  )
}

export default AdminAndAbs